import { RefreshCw } from "lucide-react";
import type { Channel } from "../lib/types";

interface ChannelSelectProps {
  channels: Channel[];
  value: string;
  onChange: (id: string) => void;
  onRefresh: () => void;
}

export function ChannelSelect({ channels, value, onChange, onRefresh }: ChannelSelectProps) {
  const activeChannels = channels
    .filter((channel) => channel.active)
    .slice()
    .sort((left, right) => {
      const leftType = left.type ?? left.targetType ?? "channel";
      const rightType = right.type ?? right.targetType ?? "channel";
      if (leftType !== rightType) return leftType === "channel" ? -1 : 1;
      return left.name.localeCompare(right.name);
    });

  return (
    <div className="flex gap-2">
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="focus-ring min-w-0 flex-1 rounded border border-line bg-white px-3 py-2 text-sm"
      >
        <option value="">เลือก Channel / Group</option>
        {activeChannels.map((channel) => (
          <option key={channel.id} value={channel.id}>
            [{(channel.type ?? channel.targetType ?? "channel") === "group" ? "Group" : "Channel"}] {channel.name} ({channel.telegramId})
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={onRefresh}
        className="rounded border border-line bg-white p-2 text-slate-600 hover:bg-slate-100"
        title="Refresh channels"
      >
        <RefreshCw size={18} />
      </button>
    </div>
  );
}
